'use client';

import { useState, useEffect, RefObject } from 'react';

export const useIsCentered = (
  ref: RefObject<HTMLElement | null>,
  options?: { once?: boolean; threshold?: number },
) => {
  const [isCentered, setIsCentered] = useState(false);

  const { once = false, threshold = 100 } = options || {};

  useEffect(() => {
    const checkPosition = () => {
      if (!ref.current || (isCentered && once)) return;

      const rect = ref.current.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;
      const elementCenter = rect.top + rect.height / 2;

      // Allow a range around the center
      const centered =
        elementCenter >= viewportCenter - threshold &&
        elementCenter <= viewportCenter + threshold;

      setIsCentered(centered);

      if (centered && once) {
        window.removeEventListener('scroll', checkPosition);
        window.removeEventListener('resize', checkPosition);
      }
    };

    if (!(isCentered && once)) {
      checkPosition();
      window.addEventListener('scroll', checkPosition);
      window.addEventListener('resize', checkPosition);
    }

    return () => {
      window.removeEventListener('scroll', checkPosition);
      window.removeEventListener('resize', checkPosition);
    };
  }, [ref, once, threshold, isCentered]);

  return isCentered;
};
